import { useWindowWidth } from "../../../hooks/useWindowWidth";
import { useDispatch, useSelector } from "react-redux";
import { changeCurrency } from "../../../redux/shop/currencySlice";
import { selectCurrency } from "../../../redux/shop/selectors";
import { socials } from "./socials";

import { Container } from "../../Container/Container";
import { ReactComponent as USAIcon } from "../../../icons/USAFlag.svg";
import { ReactComponent as UKIcon } from "../../../icons/UKFlag.svg";

import {
  FollowUsStyled,
  MidHeaderStyled,
  WelcomeTextStyled,
} from "./MidHeader.styled";
import { HeadSelectStyled } from "./HeadSelect.styled";
import { HeadLogoLinkStyled } from "../LowerHeader/LowerHeader.styled";
import React from "react";

export const MidHeader = () => {
  const width = useWindowWidth();

  const dispatch = useDispatch();
  const currency = useSelector(selectCurrency);

  return (
    <MidHeaderStyled>
      <Container>
        {width > 767 ? (
          <>
            <WelcomeTextStyled>
              Welcome to Kupidai online eCommerce store.
            </WelcomeTextStyled>

            <FollowUsStyled>
              <p>Follow us:</p>
              <ul>
                {socials.map(({ href, svg }) => {
                  return (
                    <li key={href}>
                      <a
                        href={href}
                        target="_blank"
                        rel="noreferrer"
                        aria-label={`Go to ${href}`}>
                        {svg}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </FollowUsStyled>
          </>
        ) : (
            <HeadLogoLinkStyled to="/">
                <img src="/logo_new.jpeg" className="rounded-full" style={{ borderRadius: '100%' }}
                      alt="Kupidai logo" loading="lazy" width="32"
                     height="32"/>
                Kupidai
            </HeadLogoLinkStyled>
        )}

          <HeadSelectStyled
              defaultValue={{value: "USA", label: "Eng (UK)" }}
          isSearchable={false}
          aria-label="Select language"
          classNamePrefix="Select"
          options={[
            {
              value: "USA",
              label: (
                <>
                  <USAIcon />
                  <span>Eng (USA)</span>
                </>
              ),
            },
            {
              value: "UK",
              label: (
                <>
                  <UKIcon />
                  <span>Eng (UK)</span>
                </>
              ),
            },
          ]}
        />

        <HeadSelectStyled
          isSearchable={false}
          aria-label="Select currency"
          classNamePrefix="Select"
          options={[
            {
              value: "USD",
              label: "USD",
            },
            {
              value: "EUR",
              label: "EUR",
            },
          ]}
          value={{
            value: `${currency}`,
            label: `${currency}`,
          }}
          onChange={(e) =>
            dispatch(changeCurrency(e.value))
          }
        />
      </Container>
    </MidHeaderStyled>
  );
};
